import React, { FC } from 'react'
import classNames from 'classnames'

import { IconMoon, Typography } from '@/atoms'
import { Spacer } from '@/layout'
import {
  UseCaseCardTitleProps,
  UseCaseCardBodyProps,
  UseCaseCardProps,
  UseCaseCardItemsProps,
  UseCaseCardItemProps,
} from '@/types'
import { getStyledElementProps } from '@/utils'
import styles from './use-case-card.module.scss'

export const UseCaseCardTitle: FC<UseCaseCardTitleProps> = ({
  children,
  ...props
}) => {
  return (
    <div className={styles['title']}>
      <Typography
        variant={'headline-3'}
        tag={'span'}
        typographyColor={'white'}
        {...props}
      >
        {children}
      </Typography>
    </div>
  )
}

export const UseCaseCardBody: FC<UseCaseCardBodyProps> = ({
  children,
  ...props
}) => {
  return (
    <div className={styles['body']}>
      <Typography
        variant={'body-1'}
        tag={'span'}
        typographyColor={'white'}
        {...props}
      >
        {children}
      </Typography>
    </div>
  )
}

export const UseCaseCardItems: FC<UseCaseCardItemsProps> = ({
  items,
  ...props
}) => {
  const getIconName = (
    iconName: string | undefined | null,
    defaultIcon: string
  ) => {
    if (iconName) {
      return iconName
    } else {
      return defaultIcon
    }
  }
  return (
    <div className={styles['items']}>
      {items?.map((item: UseCaseCardItemProps) => (
        <div className={styles['item']} key={item?.key}>
          <IconMoon
            name={getIconName(item?.iconName, 'icon-check-green')}
            size={'md'}
            style={{ paddingTop: '4px' }}
          />
          <Typography
            variant={'body-1'}
            tag={'span'}
            typographyColor={'white'}
            {...props}
          >
            {item?.name}
          </Typography>
        </div>
      ))}
    </div>
  )
}

export const UseCaseCard: FC<UseCaseCardProps> = ({
  children,
  variant = 'default',
  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[variant])
  )
  return (
    <div {...styledProps}>
      {children}
      <Spacer variant={'horizontal'} size={'8x'} />
    </div>
  )
}
